export default {
    attack: {
        breakpoint: 300,
        func: function (bot, enemy, breakpoint) {
            var distance = Phaser.Math.Distance.BetweenPoints({ x: bot.x, y: bot.y }, { x: enemy.x, y: enemy.y });
            if (distance <= breakpoint) {
                bot.attack();
            }
        },
    },
    chase: {
        breakpoint: 600,
        func: function (bot, enemies, breakpoint, enemy) {
            var filtered = enemies.filter(function (e) { return e.getValue().game.is_alive && !e.getInvisible(); });
            // if (enemy) {
            var sorted = filtered.sort(function (a, b) {
                var d_a = Phaser.Math.Distance.BetweenPoints({ x: bot.x, y: bot.y }, { x: a.x, y: a.y });
                var d_b = Phaser.Math.Distance.BetweenPoints({ x: bot.x, y: bot.y }, { x: b.x, y: b.y });
                return d_a - d_b;
            });
            return sorted[0];
            // }
            // if (enemy) {
            //   if (enemy.getValue().game.is_alive) return enemy;
            //   const distance = Phaser.Math.Distance.BetweenPoints(
            //     { x: bot.x, y: bot.y },
            //     { x: enemy.x, y: enemy.y }
            //   );
            //   if (distance <= breakpoint) return enemy;
            // }
            // const index = Phaser.Math.RND.integerInRange(0, filtered.length - 1);
            // return filtered[index];
            // todo check distance
            // if less then breakpoint, return newEnemy
            // else return null
        },
    },
};
